import React from 'react'

const Heartbeat = ({show, label = "", active, noItems, onClick}) => {
	const activeClass = active === show ? "sel" : "";
	const classNames = `stat ${show} ${activeClass}`;

	return (
		<div className={classNames} onClick={onClick}>
			<strong>{typeof noItems === "number" ? noItems : " "}</strong> {`${show} ${label}`}
		</div>
	);
};
export default Heartbeat;


// WEBPACK FOOTER //
// ./src/widgets/heartbeat.jsx